import { useEffect } from "react";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import { useNativePlatform } from "@/hooks/useNativePlatform";

import NotFound from "@/pages/NotFound";
import NativeAppSkeleton from "@/components/native/NativeAppSkeleton";

/**
 * Layout error boundary — on native, recover to /auth instead of a permanent 404.
 */
const RouteErrorFallback = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const { isNative } = useNativePlatform();

  useEffect(() => {
    if (!isNative) return;
    const message =
      error instanceof Error
        ? error.message
        : isRouteErrorResponse(error)
          ? `${error.status} ${error.statusText}`
          : String(error);
    console.error("[Bilenia] Route error:", message, error);
    navigate("/auth", { replace: true });
  }, [error, isNative, navigate]);

  if (isNative) {
    return <NativeAppSkeleton />;
  }

  if (isRouteErrorResponse(error)) {
    return <NotFound />;
  }

  return <NotFound />;
};

export default RouteErrorFallback;
